module.exports = __webpack_public_path__ + "img/pager12img.29023ef6.png";